import React, {useEffect} from 'react';
import M from 'materialize-css';

import idx8 from '../Images/wa.png';
import idx9 from '../Images/mail.png';

import Formulario from './Formulario';


const Contacto = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
        <div className='row' style={{backgroundColor:"#101014", paddingTop:"20px", marginBottom:"0px"}}>
            <div className='col l2 none-mobil'>
              
            </div>
            <div className='col s12 m12 l8'>
                <p className='sub_titulo_nv_5' style={{textAlign:"center", color:"#ffffff", marginBottom:"5px"}}>¡Empecemos!</p>
                <p style={{textAlign:"center", color:"#ffffff", marginTop:"0px"}}>
                    Si tiene alguna duda, escribenos, <br/>
                    <span style={{fontWeight:"bold"}}>
                        estaremos muy felices de ayudar.
                    </span>
                </p>

                
                <div className='flexbox-boton'>
                    <div className='center-btn separacion-botones'>
                        <a target="_blank" rel="noopener noreferrer" class="btn btn-formulario-1" href='https://wa.me/523333702640?text=¡Hola buen día! ¿Me podrías dar información?'> 
                            <img src={idx8} alt="Logo WhatsApp" style={{width:"36px", height:"36px"}}></img> 
                            <p style={{margin:"0px", paddingLeft:"10px", fontWeight:"bold"}}>WhatsApp</p> 
                        </a>    
                    </div>
                    <div className='center-btn'>
                        <a target="_blank" rel="noopener noreferrer" class="btn btn-formulario-2" href='mailto:softwareover@gmail.com?Subject=¡Hola buen día! &body=¡Hola buen día!%0E¿Me podrías dar más información?'> 
                            <img src={idx9} alt="Logo Email" style={{width:"36px", height:"36px"}}></img>
                            <p style={{margin:"0px", paddingLeft:"10px", fontWeight:"bold"}}>Email</p> 
                        </a>    
                    </div>
                </div>

                <p style={{textAlign:"center", color:"#ffffff"}}>
                    O déjanos tus datos para ponernos <br/>
                    <span style={{fontWeight:"bold"}}>
                        en contacto contigo.
                    </span>
                </p>

                <Formulario />
                
            </div>
            <div className='col l2 none-mobil'>
              
            </div>
        </div>
    );
}

export default Contacto;
